// useEntrance — Aufbau-Choreografie der Leitstand-Metaphern (Auftrag H
// Schritt 6). Liefert false beim ersten Paint, true ab dem naechsten Frame:
// CSS-Transitions (Klassen .leitstand-anim*) fahren dann vom Startzustand
// (leer/0) auf den Ist-Wert. prefers-reduced-motion deaktiviert die
// Transitions per CSS — der Wert springt dann sofort auf final.

import { useEffect, useState } from "react";

export function useEntrance(): boolean {
  const [on, setOn] = useState(false);
  useEffect(() => {
    const raf = requestAnimationFrame(() => setOn(true));
    return () => cancelAnimationFrame(raf);
  }, []);
  return on;
}

export function clamp01(v: number): number {
  return Math.min(1, Math.max(0, v));
}
